import {
  WebGLRenderTarget,
  Camera,
  RGBAFormat,
  Mesh,
  Scene,
  BufferGeometry,
  BufferAttribute,
  RawShaderMaterial,
  Vector2
} from 'three'
import renderer from '../renderer'
import settings from '../settings'
import smoke from '../smokeScene'
import smokeCamera from '../camera'
import vertexShader from './vert.glsl'
import fragmentShader from './frag.glsl'
import { component } from '../../bidello'

class PostFX extends component() {
  init() {
    this.renderer = renderer
    this.pass = new Scene()
    this.dummyCamera = new Camera()
    this.resolution = new Vector2()
    this.renderer.getDrawingBufferSize(this.resolution)

    this.smokeTarget = new WebGLRenderTarget(this.resolution.x, this.resolution.y, {
      format: RGBAFormat,
      stencilBuffer: false,
      depthBuffer: true
    })

    this.target = new WebGLRenderTarget(this.resolution.x, this.resolution.y, {
      format: RGBAFormat,
      stencilBuffer: false,
      depthBuffer: true
    })

    const defines = {}
    settings.fxaa && (defines.FXAA = true)

    this.material = new RawShaderMaterial({
      defines,
      fragmentShader,
      vertexShader,
      uniforms: {
        uScene: { value: this.target.texture },
        uSmoke: { value: this.smokeTarget.texture },
        uResolution: { value: this.resolution },
        uTime: { value: 0 }
      }
    })

    const vertices = new Float32Array([-1.0, -1.0, 3.0, -1.0, -1.0, 3.0])
    const geometry = new BufferGeometry()
    geometry.setAttribute('position', new BufferAttribute(vertices, 2))

    this.triangle = new Mesh(geometry, this.material)
    this.triangle.frustumCulled = false
    this.pass.add(this.triangle)
  }

  onResize() {
    this.renderer.getDrawingBufferSize(this.resolution)
    this.target.setSize(this.resolution.x, this.resolution.y)
    this.smokeTarget.setSize(this.resolution.x, this.resolution.y)
  }

  onRaf({ now }) {
    if (this.material) {
      this.material.uniforms.uTime.value = now
    }
  }

  render(scene, camera) {
    this.renderer.setRenderTarget(this.target)
    this.renderer.render(scene, camera)
    
    this.renderer.setRenderTarget(this.smokeTarget)
    this.renderer.render(smoke, smokeCamera)

    this.renderer.setRenderTarget(null)
    this.renderer.render(this.pass, this.dummyCamera)
  }
}

export default new PostFX()
